import React from 'react';
import PropTypes from 'prop-types';
import FullTextContentComponent from '@Components/Results/reactions/reaction-details/full-text-content.component';
import externalUrl from '@Utils/ExternalUrl';
import UtilsHelper from '@Components/Results/services/utils-helper.service';

function DocumentCustomLinkComponent({ citation, getTrackingAttrs }) {
  if (!citation.fullTextUrl) {
    return null;
  }
  return (
    <a
      className="els-btn els-btn-link els-btn-xs blue-compact e2e-full-text"
      href={externalUrl(citation.fullTextUrl)}
      tabIndex="0"
      rel="noreferrer"
      target="_blank"
      aria-label="Full Text"
      {...getTrackingAttrs(
        {
          'data-tracking-type': 'linkout',
          'data-tracking-action': 'full text',
        },
        true
      )}
      data-doi={UtilsHelper.stripTags(citation.doi)}>
      <FullTextContentComponent fullTextIconUrl={citation.fullTextIconUrl} />
    </a>
  );
}

DocumentCustomLinkComponent.propTypes = {
  citation: PropTypes.object.isRequired,
  // for analytics
  getTrackingAttrs: PropTypes.func.isRequired,
};

export default DocumentCustomLinkComponent;
